'use strict';

function PlaidErrorHandler(presenter) {
  this._presenter = presenter;
  this._configs = {
    node: '.portal__primary', // If no error page node was provided, it will use .portal__primary page as default
    errorCodes: ['TRY_AGAIN_LATER', 'ACTION_TRY_AGAIN_LATER', 'NOT_SUPPORTED', 'NO_ACCOUNTS', 'UNEXPECTED_ERROR'],
    initErrorPage: true,
    errorDisplayCallback: function errorDisplayCallback() {}
  };

  this._DEBUG = false;
  if (this._DEBUG) this.pageName = '[PlaidErrorHandler]';

  this._getErrorArray = function (callback) {
    if (this._presenter.getModelProperty('banking.plaidErrorArray') && this._presenter.getModelProperty('banking.plaidErrorArray._initialized')) {
      if (typeof callback === 'function') {
        callback();
      }
    } else if (this._presenter.hasAction('banking.accounts.index_plaid_errors')) {
      this._presenter.createModel('banking.plaidErrorArray', { action: 'banking.accounts.index_plaid_errors' }, callback);
    } else {
      console.warn('PlaidErrorHandler: missing index_plaid_errors action.');
    }
  };

  this._getMogoErrorCode = function (errorCode, errorType, callback) {
    var _this = this;

    this._getErrorArray(function () {
      var errArr = _this._presenter.getModelProperty('banking.plaidErrorArray.plaid_errors');
      var mogoErrorCode = errArr.find(function (err) {
        return err.error_code === errorCode && err.error_type === errorType;
      });
      if (mogoErrorCode) {
        if (typeof callback === 'function') {
          callback(mogoErrorCode.mogo_grouping);
        }
      } else {
        console.warn('PlaidErrorHandler: missing paid error array data [errorCode:%s] [errorType:%s].', errorCode, errorType);
      }
    });
  };

  this._generateErrorPage = function (errorCode, isPlaidError, callback) {
    if (this._DEBUG) console.log(this.pageName + ' - _generateErrorPage() called');

    // Error code is in list
    if (this._configs.errorCodes.indexOf(errorCode) > -1) {
      // Error code is in list && Error code is of type TRY_AGAIN
      if (isPlaidError && errorCode === this._configs.errorCodes[0]) {
        if (typeof callback === 'function') {
          if (this._DEBUG) console.log(this.pageName + ' - _generateErrorPage() - Error code is of type - \'TRY_AGAIN_LATER\' - setting isPlaidErrorPage var to false');

          callback({ isPlaidErrorPage: false });
        }
        return;
      }

      if (errorCode === this._configs.errorCodes[1]) {
        errorCode = this._configs.errorCodes[0];
      }

      $(this._configs.node).mogo().create('PlaidBankError', {
        errorType: errorCode,
        callback: this._configs.errorDisplayCallback
      });

      if (typeof callback === 'function') {
        callback({ isPlaidErrorPage: true });
      }
    } else if (typeof callback === 'function') {
      if (this._DEBUG) {
        console.log(this.pageName + ' - _generateErrorPage() - Error code is not in errorCodes List - setting isPlaidErrorPage var to false');
      }
      callback({ isPlaidErrorPage: false });
    }
  };

  /*
    Invoke error page based on provided error info.
    You can provide either plaid_error_code + plaid_error_type or just mogo_error_code.
    Arguments:
        errorCode [string] (required):
            Plaid error code or mogo error code.
        errorType [string] (optional):
            Plaid error type. If mogo error code is provided, no need to provide errorType.
        callback [function] (optional):
            if a function, it is called after the error page is invoked
        isPlaidError [boolean] (optional):
            if it is a plaid TRY_AGAIN_LATER error, it will not display custom UI
    Returns:
        no return value.
   */

  this.invokeError = function (errorCode, errorType, callback, isPlaidError) {
    if (this._DEBUG) console.log(this.pageName + ' - invokeError() called');

    if (this._configs.initErrorPage === false) {
      callback({
        errorType: errorType,
        errorCode: errorCode
      });
    } else {
      this._invokeErrorPage(errorCode, errorType, callback, isPlaidError);
    }
  };

  // isPlaidError is true for any errors that have:
  // {mogo_grouping: "TRY_AGAIN_LATER"}
  this._invokeErrorPage = function (errorCode, errorType, callback, isPlaidError) {
    var _this2 = this;

    if (this._DEBUG) console.log(this.pageName + ' - _invokeErrorPage() called');

    if (errorCode) {
      if (errorType) {
        this._getMogoErrorCode(errorCode, errorType, function (mogoErrorCode) {
          _this2._generateErrorPage(mogoErrorCode, isPlaidError, callback);
        });
      } else {
        this._generateErrorPage(errorCode, isPlaidError, callback);
      }
    } else if (typeof callback === 'function') {
      callback({ isPlaidErrorPage: false });
    }
  };
}